import { createSlice } from '@reduxjs/toolkit'
import {getModelsPag, getModelsPagCount, getMasterModels, getModels} from "./thunks"

const initialState= {
  list: {
    pageIndex: 0,
    totalRecords: 50,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: []
  },
  loading: "idle",
  loadingCount:"idle",
  loadingModels:"idle",
  models: [],
  error: null }

const modelSlice = createSlice({
  name: 'models',
  initialState,
  reducers: {
    clearModelError:(state)=>{
      state.error= null
    },
    setModelFilters:(state, action)=>{
      state.filters= action.payload
    }
  },
  extraReducers: {
    [getModelsPag.pending]: (state) => {
        state.loading = "loading";
        state.error = null
      },
    [getModelsPag.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.list.elements = action.payload.elements;
    },
    [getModelsPag.rejected]: (state, action) => {
        state.loading = "failed";
        state.error = action.error.message
    },
    [getModelsPagCount.pending]: (state) => {
      state.loadingCount = "loading"; 
      state.error = null
    },
    [getModelsPagCount.fulfilled]: (state, action) => {
      state.loadingCount = "succeeded";
      state.list.pageIndex = action.payload.pageIndex;
      state.list.totalRecords = action.payload.totalRecords;
      state.list.totalPages = action.payload.totalPages;
      state.list.hasPreviousPage = action.payload.hasPreviousPage;
      state.list.hasNextPage =action.payload.hasNextPage;

    },
    [getModelsPagCount.rejected]: (state, action) => {
      state.loadingCount = "failed"; 
      state.error = action.error.message
    },
    [getMasterModels.pending]: (state)=>{
      state.loadingModels = "loading";
      state.error = null
    },
    [getMasterModels.fulfilled]: (state, action) =>{
      state.models = action.payload;
      state.loadingModels = "succeeded"
    },
    [getMasterModels.rejected]: (state, action) =>{
      state.loadingModels = "failed";
      state.error = action.error.message
    },
    [getModels.pending]: (state)=>{
      state.loadingModels = "loading";
      state.error = null
    },
    [getModels.fulfilled]: (state, action) =>{
      state.models = action.payload;
      state.loadingModels = "succeeded"
    },
    [getModels.rejected]: (state, action) =>{
      state.loadingModels = "failed";
      state.error = action.error.message
    },
  }
})

export const {clearModelError: clearModelError, setModelFilters: setModelFilters} = modelSlice.actions;

export default modelSlice.reducer
